// extracted by mini-css-extract-plugin
export var localeSelector = "_4u-0";